export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
    id: "WiC",
    offset: -70,
  },
  {
    title: "About Us",
    url: "/",
    cName: "nav-links",
    id: "About",
    offset: -60,
  },
  {
    title: "Events",
    url: "/",
    cName: "nav-links",
    id: "Event",
    offset: -170,
  },
  {
    title: "Tech Blog",
    url: "/",
    cName: "nav-links",
    id: "Blog",
    offset: -150,
  },
  {
    title: "Join Us",
    url: "/",
    cName: "nav-links",
    id: "Join",
    offset: 0,
  },
];

export default MenuItems;
